var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShoppingJewelryDiamond1DiamondMoneyPaymentFinanceWealth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.01541 5.065C4.46791 6.34134 2.34494 9.08885 1.5 11.7012C2.73174 14.1646 7.57624 20.7814 12.7223 25.5597C13.4452 26.2309 14.5548 26.2309 15.2777 25.5597C20.4238 20.7814 25.2683 14.1646 26.5 11.7012C25.6551 9.08885 23.5321 6.34134 21.9846 5.065C21.6794 4.81325 21.2888 4.70117 20.8932 4.70117H7.10684C6.71119 4.70117 6.32064 4.81325 6.01541 5.065Z",
    stroke: "#FF8B3E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.51562 11.7012H26.4922",
    stroke: "#FF8B3E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.70117L14 11.7012L21 4.70117",
    stroke: "#FF8B3E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11.7012V26.6777",
    stroke: "#FF8B3E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingJewelryDiamond1DiamondMoneyPaymentFinanceWealth);
export default __webpack_public_path__ + "static/media/shopping-jewelry-diamond-1--diamond-money-payment-finance-wealth.1ddb1b706064c94b3f6b7c5a8ea4b4b8.svg";
export { ForwardRef as ReactComponent };